import type { ReactNode } from 'react';

export const symbol_timer_3: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M591-200H369q-17 0-28-11.74-11-11.73-11-28.5 0-16.76 11.67-28.26Q353.33-280 370-280h221v-160H411q-17 0-28-11.74-11-11.73-11-28.5 0-16.76 11.67-28.26Q395.33-520 412-520h179v-160H369q-17 0-28-11.74-11-11.73-11-28.5 0-16.76 11.67-28.26Q353.33-760 370-760h221q33.33 0 56.67 23.33Q671-713.33 671-680v131q0 29-19.25 50T605-478q27.5 0 46.75 19.54T671-411v131q0 33.33-23.33 56.67Q624.33-200 591-200Z"
		/>
	</svg>
);
